import { Box, InputAdornment, TextField } from "@mui/material"
import { makeStyles } from "tss-react/mui"
// import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/pro-light-svg-icons"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
// import { tailwindPalette } from "../../../../../../theme/tailwindPalette"

const useStyles = makeStyles()((theme) => ({
    searchContainer: {
        position: "sticky",
        backgroundColor: tailwindPalette.sky[50],
        top: 0,
        zIndex: 2,
    },
    searchInput: {
        width: "100%",
        color: theme.palette.text.secondary,
        fontSize: "1rem",
        borderBottom: `1px solid ${tailwindPalette.slate[400]}`,
        ".MuiInput-root": {
            padding: "0.75rem 0.25rem 0.75rem 1rem",
        },
        ".MuiInput-root:before": {
            display: "none",
        },
        ".MuiInput-input": {
            padding: "0 !important",
            "&::placeholder": {
                color: theme.palette.text.secondary,
            },
        },
    },
}))

export function SearchOrdersInPopup({
    searchQuery,
    setSearchQuery,
}: {
    searchQuery: string
    setSearchQuery: (query: string) => void
}) {
    const { classes } = useStyles()

    return (
        <Box className={classes.searchContainer}>
            <LocalizedStrict attrs={{ placeholder: true }} id="merchant-receipt-dropdown-search-label">
                <TextField
                    variant="standard"
                    size="small"
                    placeholder="Search..."
                    className={classes.searchInput}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                    focused={false}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <FontAwesomeIcon icon={faSearch} color="#000000" />
                            </InputAdornment>
                        ),
                    }}
                />
            </LocalizedStrict>
        </Box>
    )
}
